import { useEffect } from 'react'
import { scrollFocus } from '..'

function FieldError({ error, field, setError, fieldRef }) {
    useEffect(() => {
        if (error && error.field === field) {
            fieldRef && scrollFocus(fieldRef)
            const timeout = setTimeout(() => {
                setError(null)
            }, [4000])

            return () => {
                clearTimeout(timeout)
            }
        }
    }, [error])

    return (
        <>
            {
                error && error.field === field &&
                <div className='fieldError'>
                    {error.error_message}
                </div>
            }
        </>
    )
}

export default FieldError